import {
    OVERVIEW_PANEL_CHANGE_CURRENT,
    OVERVIEW_PANEL_HIDE,
    OVERVIEW_PANEL_SET_CURRENT,
    OVERVIEW_PANEL_SET_VISIBILITY
} from './types';

export const actions = {
    [OVERVIEW_PANEL_CHANGE_CURRENT]: ({ commit }, payload) => {
        commit(OVERVIEW_PANEL_SET_CURRENT, payload);
    },
    [OVERVIEW_PANEL_HIDE]: ({ commit }, payload) => {
        commit(OVERVIEW_PANEL_SET_VISIBILITY, false);
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/actions.js